import { post } from './request'

export function baseStationAdd(data) {
  return post('/api/BaseStation/Add', data)
}

export function baseStationUpdate(data) {
  return post('/api/BaseStation/Update', data)
}

export function baseStationList(data) {
  return post('/api/BaseStation/List', data)
}

export function baseStationDetail(data) {
  return post('/api/BaseStation/Detail', data)
}

export function baseStationDelete(data) {
  return post('/api/BaseStation/Delete', data)
}

export function baseStationBind(data) {
  return post('/api/BaseStation/Bind', data)
}

/** multipart 批量导入基站，字段名 file */
export function baseStationImport(file) {
  const fd = new FormData()
  fd.append('file', file)
  return post('/api/BaseStation/Import', fd, { timeout: 120000 })
}
